<template>

    <modal :show="showModal" @closeModal="close">

        <div class="mep">

            <img src="/img/providers/microsoft.png" class="logo-microsoft" v-if="isMicrosoft">
            <img src="/img/providers/illustration-technical-error.svg" v-else class="logo">

            <p class="text-1">{{ $tc('unsupported_provider_title', 0, {provider}) }}</p>

            <p class="text-2">{{ firstText }}</p>

            <p class="text-3">{{ secondText }}</p>

            <div class="gap"></div>

            <div class="line" v-show="provider">
                <checkbox @change="acceptCallback = $event"></checkbox>
                <span class="text">{{ $t('login_provider_impossible_to_connect_consent_box') }}</span>
            </div>

            <button  v-show="provider"
                     class="cta-valid"
                    :class="{'cta-valid-disable': !acceptCallback }"
                    @click="validate">
                <lottie-loader v-if="requesting" :size="24" ></lottie-loader>
                <span v-else>{{ $t('global_validate') }}</span>
            </button>
            <button class="cta-cancel" @click="cancel">{{ $t('global_back') }}</button>

        </div>

    </modal>

</template>

<script>
import Api from '../../api'

import Tag from '../../modules/tag'

import Checkbox from '../../components/inputs/Checkbox'
import LottieLoader from '../../components/lottie/LottieLoader'
import Modal from '../../components/modal/Modal'

export default {

    name: 'modal-error-provider',

    components: {
        Checkbox,
        LottieLoader,
        Modal
    },

    props: {
        email: {
            type: String,
            default: ''
        }
    },

    computed: {
        isMicrosoft() {
            return this.provider && this.provider.toLowerCase() === 'microsoft'
        },

        firstText() {
            return this.provider
                ? this.$tc('login_provider_impossible_to_connect_consent', 0, {provider: this.provider})
                : this.$t('login_provider_impossible_to_connect_unknown_consent')
        },

        secondText() {
            return this.provider
                ? this.$tc('login_provider_impossible_to_connect_consent_2', 0, {provider: this.provider})
                : ''
        }
    },

    data() {
        return {
            showModal: false,
            provider: '',
            shutdown: false,
            acceptCallback: false,
            requesting: false
        }
    },

    methods: {

        show(error) {
            Tag.popupAmplitude(this, 'unknown_provider')
            this.requesting = false
            this.provider = error && error.data && error.data.provider
            this.shutdown = error && error.data && error.data.reason === 'shutdown'
            this.showModal = true
        },

        cancel() {
            Tag.clickAll(this, 'cancel', this.provider, 'unknown_provider')
            this.close()
        },

        async validate() {
            if (this.acceptCallback) {
                this.requesting = true
                Tag.clickAll(this, 'validate', this.provider, 'unknown_provider')
                await Api.auth.futureContact(this.email)
                this.requesting = false
                this.close()
            }
        },

        close() {
            this.$emit('close')
            this.showModal = false
        }
    }
}

</script>

<style lang="scss" scoped>

.mep {
    padding: 32px 20px;
    text-align: start;
    max-width: 454px;

    color: $neutralsMoon;
    font-size: 17px;
    font-weight: 600;
    line-height: 24px;


    @media screen and (min-width: $above-tablet-length) {
        text-align: start;
    }

    .logo {
        height: 96px;
        object-fit: contain;
    }

    .logo-microsoft {
        height: 32px;
        object-fit: contain;
    }

    .text-1 {
        margin-top: 24px;
        color: $charcoal;
        font-size: 24px;
        font-weight: 600;
        line-height: 28px;
    }

    .text-2 {
        margin-top: 16px;
    }

    .text-3 {
        margin-top: 8px;
    }

    .gap {
        margin-top: 24px;
    }

    .line {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        .text {
            margin: 0 8px;
            font-weight: 600;
        }
    }

    .cta-valid {
        margin-top: 24px;
        display: flex;
        padding: 16px 40px;
        justify-content: center;
        align-items: center;
        color: $white;
        text-align: center;
        width: 100%;
        border-radius: 32px;
        background-color: $aquamarine;
        font-size: 17px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
    }

    .cta-cancel {
        margin-top: 8px;
        display: flex;
        padding: 12px 36px;
        justify-content: center;
        align-items: center;
        color: $charcoal;
        text-align: center;
        width: 100%;
        border-radius: 32px;
        background-color: $white;
        font-size: 17px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px;
        border: 4px solid var(--Neutrals-Platinum, #E7E7E8);
    }

    .cta-valid-disable {
        background-color: $timberwolf;
        color: $neutralsMoon;
        cursor: not-allowed;
    }

}

</style>
